import { render, staticRenderFns } from "./SectionItemDescription.vue?vue&type=template&id=2ebc7560&scoped=true&lang=pug&"
import script from "./SectionItemDescription.vue?vue&type=script&lang=js&"
export * from "./SectionItemDescription.vue?vue&type=script&lang=js&"
import style0 from "./SectionItemDescription.vue?vue&type=style&index=0&id=2ebc7560&lang=scss&scoped=true&"
import style1 from "./SectionItemDescription.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ebc7560",
  null
  
)

export default component.exports